import { Injectable, Injector } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BaseNotificationModalComponent } from './base-notification-modal/base-notification-modal.component';
import { MODAL_DATA } from './tokens/modal-data.token';

@Injectable()
export class ModalService {
    private ngbModalService: NgbModal;

    constructor(private readonly injector: Injector) {}

    public init() {
        this.ngbModalService = this.injector.get(NgbModal);
    }

    public openModalWithInjectData<T = any>(modalComponent: any, data: T) {
        const modalRef = this.ngbModalService.open(BaseNotificationModalComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'notification-modal',
            injector: Injector.create({
                providers: [
                    {
                        provide: MODAL_DATA,
                        useValue: {
                            modalComponent,
                            data,
                        },
                    },
                ],
            }),
        });
        return modalRef;
    }

    public open(modalComponent: any, options?: NgbModalOptions) {
        const modalRef = this.ngbModalService.open(modalComponent, options);
        return modalRef;
    }

}



// WEBPACK FOOTER //
// ./ts/app/shared/modal.service.ts